export function assertNever(x: never): never {
    throw new Error("Exhaustive check failed, object received: " + x);
}
